import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconTrendingDownwardsStyle0 = gravityIconIndividualCss;

const GravityIconTrendingDownwards = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '5e4b7e1660fbff3d1339f9ebd5fcd3c827c194b4', color: this.color, size: this.size }, h("svg", { key: '17bc1170239d9aa975323a25d3bdde754353a48b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'b03fc257a5be2e94e0975a105b4cff268ac24eb4', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m12.994 11.934 2.497-2.496A.3.3 0 0 1 16 9.65v6.053a.29.29 0 0 1-.297.297H9.65a.3.3 0 0 1-.212-.51l2.496-2.495-6.718-6.718a.5.5 0 0 1 0-.707l.354-.354a.5.5 0 0 1 .707 0l6.717 6.718Z", fill: "currentColor" }))));
    }
};
GravityIconTrendingDownwards.style = GravityIconTrendingDownwardsStyle0;

export { GravityIconTrendingDownwards as gravity_icon_trending_downwards };

//# sourceMappingURL=gravity-icon-trending-downwards.entry.js.map